import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { DriverPaymentInfo } from './DriverPaymentInfo';
import { DriverSettlementHistory } from './DriverSettlementHistory';
import { DriverBalanceCard } from '@/components/features/financials/DriverBalanceCard';
import { DriverDetails } from '@/types/driver.types';
import { Receipt, ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';

interface DriverFinancialDashboardProps {
  driverId: string;
  driver: DriverDetails;
}

export function DriverFinancialDashboard({ driverId, driver }: DriverFinancialDashboardProps) {
  const [showSettlements, setShowSettlements] = useState(false);

  return (
    <div className="space-y-4" dir="rtl">
      <DriverBalanceCard driverId={driverId} />

      <DriverPaymentInfo driver={driver} />

      <Card>
        <CardHeader className="pb-3">
          <Button
            variant="ghost"
            className="w-full h-auto p-3 flex items-center justify-between hover:bg-accent/50"
            onClick={() => setShowSettlements(!showSettlements)}
          >
            <div className="flex items-center gap-2">
              <Receipt className="h-4 w-4" />
              <CardTitle className="text-base">سجل التسويات</CardTitle>
            </div>
            {showSettlements ? (
              <ChevronUp className="h-4 w-4" />
            ) : (
              <ChevronDown className="h-4 w-4" />
            )}
          </Button>
        </CardHeader>
        {showSettlements && (
          <CardContent>
            <DriverSettlementHistory
              driverId={driverId}
              showCommission={driver.payment_type === 'commission'}
              commissionRate={Number(driver.commission_rate) || 0}
            />
          </CardContent>
        )}
      </Card>
    </div>
  );
}
